/* -----------------UI--------------- */
import { Dialog } from "react-native-paper";

import DialogWrapper from "@memorang/ui/components/DialogWrapper";
/* -----------------Child components--------------- */
import { t } from "i18next";
import AppReviewForm from "../AppReviewForm";

/* -----------------Constants--------------- */
import { dialogTexts } from "../../constants";

/* -----------------Helpers & Hooks--------------- */
import { useReview } from "@features/feedback/hooks/useReview";
import Button from "@memorang/ui/components/Button";
import { useKeyboard } from "@react-native-community/hooks";

export const AppReviewDialog = () => {
	const {
		handleDismiss,
		handleReviewButtonsClick,
		handleMaybeLater,
		showReviewDialog,
	} = useReview();

	const { keyboardHeight } = useKeyboard();

	const config = dialogTexts.prompt;

	return (
		<>
			<DialogWrapper
				visible={Boolean(showReviewDialog)}
				handleClose={handleDismiss}
				bottom={keyboardHeight ? keyboardHeight - 200 : 0}
			>
				<Dialog.Icon icon="message-star-outline" />
				<Dialog.Title
					style={{
						textAlign: "center",
					}}
				>
					{t(config.title)}
				</Dialog.Title>
				<Dialog.Content>
					<AppReviewForm handleButtonsClick={handleReviewButtonsClick} />
				</Dialog.Content>
				<Dialog.Actions>
					<Button onPress={handleMaybeLater}>
						{t("dashboard.reviewPrompt.cta")}
					</Button>
				</Dialog.Actions>
			</DialogWrapper>
		</>
	);
};
